// API client for AfroConnect web app
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export function getToken() {
  return localStorage.getItem('auth_token');
}

export function setToken(token) {
  localStorage.setItem('auth_token', token);
}

export function clearToken() {
  localStorage.removeItem('auth_token');
}

export async function api(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${BASE_URL}/api${path}`, { ...options, headers });

  if (!res.ok) {
    let detail;
    try {
      const body = await res.json();
      detail = body.detail || `HTTP ${res.status}`;
    } catch {
      detail = `HTTP ${res.status}`;
    }
    // Throw an Error annotated with the HTTP status so callers (e.g. AuthContext)
    // can distinguish a real 401 from a transient network/5xx blip.
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }

  // Some endpoints (e.g. logout) might return empty
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}
